import { QButton, useCurrentUser } from '@qualio/ui-components';
import { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentOverviewContext } from '../../Context';
import { shouldShowEditPropertiesButton } from '../../RenderLogic';
import { EditDocumentPropertiesModal } from '../EditDocumentPropertiesModal';

export const EditPropertiesButton = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const { qualioDocument } = useContext(DocumentOverviewContext);
  const canEditProperties = useMemo(
    () => shouldShowEditPropertiesButton(qualioDocument, currentUser),
    [currentUser, qualioDocument],
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!canEditProperties) {
    return null;
  }

  return (
    <>
      <QButton
        data-cy="document-edit-properties-button"
        variant="ghost"
        onClick={() => setIsModalOpen(true)}
      >
        {t('buttons.edit')}
      </QButton>
      <EditDocumentPropertiesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
